"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendBoxValue;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendBoxValue() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var sendBoxValue = _ref.sendBoxValue;
    return sendBoxValue;
  }), (0, _useWebChatAPIContext.default)().setSendBox];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTZW5kQm94VmFsdWUiLCJ1c2VTZWxlY3RvciIsInNlbmRCb3hWYWx1ZSIsInVzZVdlYkNoYXRBUElDb250ZXh0Iiwic2V0U2VuZEJveCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVNlbmRCb3hWYWx1ZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VTZWxlY3RvciB9IGZyb20gJy4vaW50ZXJuYWwvV2ViQ2hhdFJlZHV4Q29udGV4dCc7XG5pbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNlbmRCb3hWYWx1ZSgpOiBbc3RyaW5nLCAodmFsdWU6IHN0cmluZykgPT4gdm9pZF0ge1xuICByZXR1cm4gW3VzZVNlbGVjdG9yKCh7IHNlbmRCb3hWYWx1ZSB9KSA9PiBzZW5kQm94VmFsdWUpLCB1c2VXZWJDaGF0QVBJQ29udGV4dCgpLnNldFNlbmRCb3hdO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQThEO0VBQzNFLE9BQU8sQ0FBQyxJQUFBQyxnQ0FBQSxFQUFZO0lBQUEsSUFBR0MsWUFBSCxRQUFHQSxZQUFIO0lBQUEsT0FBc0JBLFlBQXRCO0VBQUEsQ0FBWixDQUFELEVBQWtELElBQUFDLDZCQUFBLElBQXVCQyxVQUF6RSxDQUFQO0FBQ0QifQ==